import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { useSessionCalcData, useInvalidateSession } from '../../hooks/useSessions';
import SessionDetails from './SessionDetails/SessionDetails';

export default function SessionView(): ReactElement {
  const { sessionId } = useParams();

  if (!sessionId) {
    return <div>Missing session id!</div>;
  }

  if (sessionId === 'new') {
    return <NewSessionDetails />;
  }

  return <ExistingSessionDetails sessionId={sessionId} />;
}

const NewSessionDetails = () => {
  const handleRefetch = async () => {
    // No-op for new sessions
  };

  return (
    <SessionDetails
      sessionId={'new'}
      session={{}}
      isSessionPending={false}
      isSessionFetching={false}
      isNew={true}
      refetchSession={handleRefetch}
    />
  );
};

const ExistingSessionDetails = ({ sessionId }: { sessionId: string }) => {
  const { data: session, isPending: isSessionPending, isFetching: isSessionFetching } = useSessionCalcData(sessionId);
  const invalidateSession = useInvalidateSession(sessionId);

  return (
    <SessionDetails
      sessionId={sessionId}
      session={session}
      isSessionPending={isSessionPending}
      isSessionFetching={isSessionFetching}
      isNew={false}
      refetchSession={invalidateSession}
    />
  );
};
